<template>
  <div>
     <!-- <div class="header">
       <span class="h_back" @click="back"></span>
       <span class="h_title ellipse">{{detail.name}}</span>
       <span class="h_chack off" v-if="!isCollect" @click="collect"></span>
       <span class="h_chack on" v-else @click="collect"></span>
     </div> -->
     <div class="h_msg">
       <div class="h_img">
         <img :src="themeImg||''" :onerror="defaultImg" alt="" class="h_imgbg">
         <img src="static/images/recorder.svg" alt="" v-show="detail.fAudio"  v-if="!isRecording" class="recorder" @click="checkRecord">
         <img src="static/images/recorders.gif" alt=""  v-show="detail.fAudio" v-else class="recorder" @click="checkRecord">


         <audio id="audio" :src="detail.fAudio"></audio>
       </div>
       <p class="cp_name">{{detail.name}}</p>
       <ul class="cp_base">
         <li><img src="static/images/cp_level.svg" alt=""><span>{{detail.collectionLevel | collectLeve}}</span></li>
         <li><img src="static/images/cp_time.svg" alt=""><span>{{detail.yearName}}</span></li>
         <li><img src="static/images/cp_icon.svg" alt=""><span>{{detail.categoryName}}</span></li>
         <li class="mum_li"><img src="static/images/cp_mumicon.svg" alt=""><span class="cp_mum">{{detail.museumName}}</span></li>
       </ul>
       <!-- <p class="cp_indroduce">藏品简介</p>
       <div class="cp_content">
        {{detail.description}}
       </div> -->
     </div>
   </div>
</template>

<script>
  import {api} from '../global/api';
  import { Indicator } from 'mint-ui';
  import { Toast } from 'mint-ui';
  import { MessageBox } from 'mint-ui';
    export default {
        name: "collection-detail",
        data(){
          return{
            defaultImg: 'this.src="' + require('@/assets/images/no-data.png') + '"',  // 默认图片

            id:"",
            detail:{},//详情数据
            isRecording:false,
            isCollect:false,
            collectionUnit:"",
            themeImg:""
          }
        },
        mounted(){
            this.init();
        },
        methods:{
          back(){
            this.$router.go(-1);
          },
          goRouter(str){
            switch(str)
            {
              case "back":
                this.$router.back();
                break;

              case "home":
                this.$router.push("/");
                break;

              case "map":
                this.$router.push({path:"mumDetail",query:{id:this.collectionUnit}});
                break;
            }
          },
          collect(){
            let that = this;
            this.id = this.$route.query.id;
            let params={"userID":localStorage['userid']||"","token":localStorage['token']||"","collectID":this.id,"type":1};
            if(this.isCollect==true){
              this.$http.get(api.delCollect, {params:params}).then(response  => {

                if(response.data.success==1){
                  this.isCollect=false;
                  let instance = Toast(
                    {
                      message: '取消成功！',
                      position: 'center',
                      duration: 2000,
                      iconClass: 'icon icon-success'
                    }
                  );
                  setTimeout(() => {
                    instance.close();
                  }, 2000);

                }else{
                  this.isCollect=false;
                  let instance = Toast(
                    {
                      message: '取消失败！',
                      position: 'center',
                      duration: 2000,
                      iconClass: 'icon icon-fail'
                    }
                  );
                  setTimeout(() => {
                    instance.close();
                  }, 2000);
                }
              }, response => {
                console.log("请求失败了");
              })
            }else{
              this.$http.get(api.addCollect, {params:params}).then(response  => {

                if(response.data.success==1){
                  this.isCollect=true;
                  let instance = Toast(
                    {
                      message: '收藏成功！',
                      position: 'center',
                      duration: 2000,
                      iconClass: 'icon icon-success'
                    }
                  );
                  setTimeout(() => {
                    instance.close();
                  }, 2000);

                }else if(response.data.success==999){
                  //this.$router.push({ path: 'my/login'});

                  MessageBox.confirm('', {
                    message: '登录后收藏，<br>是否现在去登录？',
                    title: '',
                    confirmButtonText: '稍后',
                    cancelButtonText: '登录'
                  }).then(action => {
                    if (action == 'confirm') {     //确认的回调



                    }else{
                      that.$router.push({ path: 'my/login'});
                    }
                  }).catch(err => {
                    if (err == 'cancel') {     //取消的回调
                      that.$router.push({ path: 'my/login'});
                    }
                  });
                }else{
                  this.isCollect=false;
                  let instance = Toast(
                    {
                      message: '收藏失败！',
                      position: 'center',
                      duration: 2000,
                      iconClass: 'icon icon-fail'
                    }
                  );
                  setTimeout(() => {
                    instance.close();
                  }, 2000);
                }
              }, response => {
                console.log("请求失败了");
              })
            }



          },
          checkRecord(){
            this.isRecording=!this.isRecording;
            var music = document.getElementById("audio");
            if(music.paused){
              music.play();
            }else{
              music.pause();
            }
          },
          init(){
            let that = this;
            this.id = this.$route.query.id;
            Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
            this.$http.get(api.getCollectionById+"?id="+that.id+"&&userid="+localStorage['userid'], {timeout:8000}).then(response  => {
              console.log("请求成功了1");
              Indicator.close();

              if(response.data.data.collectionInfo.iscollection){

                response.data.data.collectionInfo.iscollection==0?that.isCollect=false:that.isCollect=true;
              }
              // console.log(response.data.subjects);
              that.detail = response.data.data.collectionInfo;
              response.data.data.collectionInfo.pics && response.data.data.collectionInfo.pics[0] && (that.themeImg = response.data.data.collectionInfo.pics[0].url);
              that.collectionUnit = response.data.data.collectionInfo.collectionUnit;
              // console.log(that.showingDates);
            }, response => {
              console.log("请求失败了");
            })
          }

        }
    }
</script>

<style scoped>
  .header{
    width:100%;
    height: 2.25rem;
    background-color: rgba(196, 77, 65, 1);
    position: fixed;
    top: 0;
    z-index: 100;
  }
  .header span{
    display: block;
  }
  .h_title{
    height:  2.25rem;
    line-height:  2.25rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    width: 9rem;
    margin: 0 auto;
  }
  .h_back{
     background: url("../../static/images/cp_backbtn.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    position: absolute;
    left: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .h_chack{
    width: 1rem;
    height: 1rem;
    position: absolute;
    right: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .off{
    background: url("../../static/images/checkoff.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .on{
    background: url("../../static/images/checkon.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .h_msg{
     width: 17.25rem;
     padding: 1rem .75rem;
    /* margin-top: 2.25rem; */
  }
  .h_img{
    position: relative;
    text-align: center;
  }
  .h_imgbg{
    width: 17.25rem;
    height: 17.25rem;
    border-radius: 0.4rem;
    display: block;
    object-fit: cover;
  }
  .recorder{
    position: absolute;
    right: .6rem;
    top: .45rem;
    width: 2.1rem;
    height: 2.1rem;
  }
  .cp_name{
    width: 100%;
    line-height: 1.1rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    overflow:hidden;
    text-overflow:ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制显示的行数 */
    line-clamp: 2; /* 标准属性，提高兼容性 */
    -webkit-box-orient: vertical;
    margin-top: 1rem;
    margin-bottom: .5rem;
  }
  .cp_base:after{
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  .cp_base li{
    float: left;
    width: 100%;
    box-sizing: border-box;
    min-height: 1.8rem;
    border-radius: 0.4rem;
    /* margin-right: .75rem; */
    margin-bottom: .5rem;
    background-color: rgba(241, 241, 242, 1);
    padding: .5rem .55rem;
    display: flex;
    align-content: center;
  }
  /* .cp_base li:nth-child(2n){
    margin-right: 0;
  } */
  .cp_base img{
    display: inline-block;
    width: .8rem;
    height: .8rem;
  }
  .cp_base span{
    width: 6rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFang-SC-Regular;
    /* overflow:hidden;
    text-overflow:ellipsis; */
    vertical-align: top;
    /* white-space:nowrap; */
    display: inline-block;
    margin-left: .5rem;
    flex: 1;
  }
  .gotomap{
    width: .34rem;
    height: .6rem;
    position: absolute;
    right:.65rem;
    top: 0;
    bottom:0;
    margin: auto;
  }


  .mum_li{
    position: relative;
  }
  .cp_indroduce{
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    margin-top: .5rem;
    margin-bottom: .75rem;
  }
  .cp_content{
    width: 100%;
    line-height: 1.2rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: justify;
    font-family: PingFang-SC-Regular;

  }
</style>



// WEBPACK FOOTER //
// src/view/collectionDetail.vue